import React, { Fragment } from "react";

import { Button, Dialog, DialogContent, DialogContentText, TextField, DialogActions, DialogTitle, InputLabel, Select, MenuItem } from '@material-ui/core'
import { Paper } from "../../../interfaces/shared/Paper";
import ExaminerPaperList from "../papers/ExaminerPaperList";
import { Examiner } from "../../../interfaces/examiner/Examiner";
import { ExaminerRoles, ExaminerRole } from "../../../constants/examinerRole";
import { examinerHasRole } from "../../../components/RoleAccess";

interface Props {
    examiner:Examiner
    onEdit:(examiner:Examiner) => void
    onClose:() => void
    isSuperuser:boolean
}

interface State {
    examiner:Examiner
}

export default class EditExaminerDialog  extends React.Component<Props, State> {

    constructor(props:Props) {

        super(props)

        this.state = {
            examiner: {
                ...this.props.examiner,
                role: this.props.examiner.role ?? ExaminerRoles.examiner
            }
          }
    }

    render() {
        let canPressAdd = this.state.examiner.password ? this.state.examiner.password.length>=12 : true
        let canPressRename = this.props.isSuperuser ? (this.state.examiner.username ? this.state.examiner.username.length>3 : true) : true
        let canPress = canPressAdd && canPressRename
        return (
            <div>
            <Dialog open={true} onClose={this.props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{`Edit ${this.state.examiner.username}`}</DialogTitle>
                <DialogContent>
                {this.props.isSuperuser && <TextField
                            margin="dense"
                            label="Username"
                            fullWidth
                            variant="filled"
                            name="username"
                            defaultValue={this.state.examiner.username}
                            onChange={this.handleChange}
                            helperText="Usernames must be >3 characters and unique"
                />}
                <TextField
                            margin="dense"
                            label="Password"
                            fullWidth
                            variant="filled"
                            name="password"
                            defaultValue={this.state.examiner.password}
                            onChange={this.handleChange}
                            helperText="Passwords must be >=12 characters"
                />
                {examinerHasRole('superuser') && (
                    <Fragment>
                        <InputLabel id="examiner-edit-role-label" style={{ marginTop: 8 }}>Role</InputLabel>
                        <Select
                            labelId="examiner-edit-role-label"
                            name="role"
                            fullWidth
                            variant="filled"
                            margin="dense"
                            value={this.state.examiner.role}
                            onChange={this.handleRoleChange}
                        >
                            {ExaminerRoles.all.map((r) => (
                                <MenuItem key={r} value={r}>{r}</MenuItem>
                            ))}
                        </Select>
                    </Fragment>
                )}
                </DialogContent>
                <DialogActions>
                <Button disabled = {!canPress} onClick={this.onEdit} color="secondary">
                    Edit
                </Button>
                <Button onClick={this.onClose} color="secondary">
                    Cancel
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        );
    }

    onClose = () => {
        this.props.onClose()
    }

    onEdit = () => {
        this.props.onEdit(this.state.examiner)
    }

    handleChange = async (ev: any) => {

        let examiner = this.state.examiner as Examiner
        let newExaminer:Examiner = { ...examiner, [ev.target.name]: ev.target.value }
        await this.setState(prevState => ({ ...prevState, examiner: newExaminer }))
    }

    handleRoleChange = async (ev: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        const role = ev.target.value as ExaminerRole
        const examiner = this.state.examiner as Examiner
        const newExaminer: Examiner = {
            ...examiner,
            role,
            superuser: role === ExaminerRoles.superuser
        }
        await this.setState(prevState => ({ ...prevState, examiner: newExaminer }))
    }

}